export default __webpack_public_path__ + "static/media/422535__killersmurf96__menu-flick-sound.e541546a.mp3";